import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import Documents from '../../../../components/Documents';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import TableActions from '../../../../components/TableActions';
import { Helpers } from '../../../../helpers/Helpers';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { OfferStatusEnum } from '../../../../models/common/Enums';
import { GetAntrepoOfferListPagingAndFilterRequest } from '../../../../models/request/antrepoOffer/GetAntrepoOfferListPagingAndFilterRequest';
import { GetAntrepoOfferListPagingAndFilterResponseItem } from '../../../../models/response/antrepoOffer/GetAntrepoOfferListPagingAndFilterResponse';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetAntrepoOfferListPagingAndFilterRequest
    getData: (_filter?: GetAntrepoOfferListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetAntrepoOfferListPagingAndFilterRequest>>
    changeOfferStatus: (_newStatus: string) => Promise<void>
    items: GetAntrepoOfferListPagingAndFilterResponseItem[]
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const AntrepoOfferListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    changeOfferStatus,
    items,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                hideSearch={true}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canDocument && (
                    <Documents
                        items={items.map(function (x) {
                            return { entityId: x.antrepoOfferId, isSelected: x.isSelected }
                        })}
                        pageName={pageName}
                    />
                )
            }

            <TableActions
                list={[
                    { bg: '#17C653', isDisabled: !(items.filter(x => x.isSelected).length == 1 && Helpers.isEmpty(items.filter(x => x.isSelected)[0].offerStatusChangeDate)), text: 'Sipariş Oluştur', onClick: () => changeOfferStatus(OfferStatusEnum.ONAYLANDI) },
                    { bg: '#F8285A', isDisabled: !(items.filter(x => x.isSelected).length == 1 && Helpers.isEmpty(items.filter(x => x.isSelected)[0].offerStatusChangeDate)), text: 'Onaylanmadı', onClick: () => changeOfferStatus(OfferStatusEnum.REDDEDILDI) },
                    { bg: 'orange', isDisabled: !(items.filter(x => x.isSelected).length == 1 && Helpers.isEmpty(items.filter(x => x.isSelected)[0].offerStatusChangeDate)), text: 'Revize', onClick: () => changeOfferStatus(OfferStatusEnum.REVIZE_EDILDI) },
                    // Kart başlığından üst şeride taşındı: yalnız tek kayıt seçiliyken ve teklif onaylıyken aktif.
                    { bg: 'orange', isDisabled: !(items.filter(x => x.isSelected).length == 1 && items.filter(x => x.isSelected)[0].offerStatusAdditionalValue1 == OfferStatusEnum.ONAYLANDI), text: 'Hızlı Karşılama Ekle', onClick: () => navigate('/welcomefast/listadd?offerId=' + items.filter(x => x.isSelected)[0].antrepoOfferId) },
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Oluşturma / Başlangıç / Bitiş Tarihi, Müşteri
                ve Teklif Durumu kolon başlığının altındaki filtrede var. Son bir aylık oluşturma
                tarihi varsayılanı "Oluşturma Tarihi" kolon filtresi olarak açılır. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/antrepooffer/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Teklif Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default AntrepoOfferListFilters;